import clsx from "clsx";
import type { LoadingSpinnerProps } from "./loadingSpinner.types";
import { getSpinnerClasses } from "./loadingSpinner.definitions";

export default function LoadingSpinner({
  size = "md",
  color = "primary",
  className,
  message = "Carregando...",
}: LoadingSpinnerProps) {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center",
        "w-full min-h-dvh"
      )}
    >
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <div className={clsx(getSpinnerClasses(size, color), className)}>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-current mx-auto"></div>
        </div>
        {message && (
          <p className="mt-4 text-raro-gray-600 font-montserrat">{message}</p>
        )}
      </div>
    </div>
  );
}
